import { render } from "./SurveyPassingModal.vue?vue&type=template&id=1b64d416&scoped=true"
import script from "./SurveyPassingModal.vue?vue&type=script&lang=js"
export * from "./SurveyPassingModal.vue?vue&type=script&lang=js"

import "./SurveyPassingModal.vue?vue&type=style&index=0&id=1b64d416&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b64d416"]])

export default __exports__